import React from 'react';

function ManageSubscriptionContent() {
  return (
    <>
      <p>Information about managing your RepoPrompt Pro subscription or license.</p>
      <h3>Managing Your Pro Subscription</h3>
      <p>You can manage your RepoPrompt Pro subscription through our customer portal:</p>
      <ul>
        <li>Either follow the link to the Polar custom portal from your order confirmation email, or</li>
        <li>Visit <a href="https://polar.sh/repo-prompt/portal/request" target="_blank" rel="noopener noreferrer">https://polar.sh/repo-prompt/portal/request</a> to access the portal</li>
      </ul>
      <h3>What Can I Do in the Customer Portal?</h3>
      <ul>
        <li>Update your billing information</li>
        <li>Change your subscription plan</li>
        <li>Cancel your subscription</li>
        <li>View past invoices</li>
        <li>Request refunds or support</li>
      </ul>
      <h3>License Management</h3>
      <p>If you have a license key:</p>
      <ul>
        <li>You can activate your license on up to 3 devices simultaneously</li>
        <li>To activate a new device, click the "Activate" button in RepoPrompt's top bar</li>
        <li>To deactivate a device, visit the customer portal or deactivate directly from within RepoPrompt</li>
      </ul>
    </>
  );
}

export default ManageSubscriptionContent;